import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  class: "th-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M11.333 7.337H12a.667.667 0 0 0 .667-.667v-.667A.667.667 0 0 0 12 5.337h-.667a.667.667 0 0 0-.666.666v.667a.667.667 0 0 0 .666.667M4 8.003h3.333a.667.667 0 1 0 0-1.333H4a.667.667 0 1 0 0 1.333M14.667 2.67H1.333a.667.667 0 0 0-.666.667v9.333a.666.666 0 0 0 .666.667h13.334a.667.667 0 0 0 .666-.667V3.337a.667.667 0 0 0-.666-.667M14 12.003H2v-8h12zM4 10.67h3.333a.667.667 0 1 0 0-1.333H4a.667.667 0 0 0 0 1.333"
    }, null, -1)
  ]))]))
}
import { markRaw } from 'vue'
export default markRaw({ render: render })